<template>
  <div>
    <v-text-field
      v-model="reference"
      label="Bible Reference"
      :error-messages="errReference"
      @focus="inputFocus"
      @input="onInput"
    />
    <template v-if="withPreview">
      <h5>Preview:</h5>
      <p>{{ text }}</p>
    </template>
  </div>
</template>

<script>
import { debounce } from 'debounce'

export default {
  name: 'BiblePassageSelect',
  data: () => ({
    reference: null,
    text: null,
    errReference: null
  }),
  props: {
    version: {
      type: String,
      default: 'kjv'
    },
    withPreview: {
      type: Boolean,
      default: true
    },
    errorMessages: {
      type: String,
      default: null
    },
    value: String
  },
  watch: {
    value: function () {
      this.reference = this.value
      this.populateText()
    },
    errorMessages: function (val) {
      if (val) {
        this.errReference = val
      } else {
        this.errReference = null
      }
    }
  },
  methods: {
    populateText: function () {
      var _this = this
      this.axios.get('/bibles/' + this.version + '/' + this.reference)
        .then(function (res) {
          _this.text = res.data.join(' ')
        })
        .catch(this.$root.apiErrorHandler(function (msg) {
          _this.text = 'Error: ' + msg
        }))
    },
    // Propagate our selection so it works with a parent v-model
    // But debounce it so we don't make API requests for Bible text on each
    // character press.
    onInput: debounce(function () {
      this.$emit('input', this.reference)
      this.populateText()
    }, 500),
    inputFocus () {
      this.errReference = null
    }
  }
}
</script>
